<div class="pill" [style]="styles">
    <span class="pill__text">{{ text }}</span>
    <button
        *ngIf="!!close.observers?.length"
        type="button"
        class="pill__close"
        (click)="handleClose()"
        aria-label="Remove"
    >
        <img src="/assets/icons/remove-icon.svg" alt="" />
    </button>
</div>
